import { createConfigExperiment, getExperiment } from '@pegasus/abtesting';
import { useSelector } from 'react-redux';

const PROJECT_ID = 'd0fcfc44-8c52-414e-8958-2e849e24d9ae';
const CCF_NEW_POSITION_CONTROL = 'control_current_ccf_position';
const CCF_NEW_POSITION_VARIANT = 'variant_new_ccf_position';

export const useCCFNewPosition = () => {
    // @ts-ignore
    const experiment = useSelector(state => getExperiment(state, PROJECT_ID));

    if (!experiment) {
        return false;
    }

    // @ts-ignore
    return experiment?.variant === CCF_NEW_POSITION_VARIANT;
};

export default createConfigExperiment({
    projectId: PROJECT_ID,
    variants: [CCF_NEW_POSITION_CONTROL, CCF_NEW_POSITION_VARIANT],
});
